var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copy-step"},[_c('div',{staticClass:"copy-step__title"},[_c('p',{staticClass:"--centered --white-text font-weight-black"},[_vm._t("title")],2)]),_c('div',{staticClass:"copy-step__body"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }